var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 20C1.875 20 1.4375 19.8125 1.0625 19.4375C0.6875 19.0625 0.5 18.625 0.5 18.125V13.6562H2.375V18.125H18.625V13.6562H20.5V18.125C20.5 18.625 20.3125 19.0625 19.9375 19.4375C19.5625 19.8125 19.125 20 18.625 20H2.375ZM9.5625 15.2187V3.625L5.8125 7.375L4.46875 6.03125L10.5 0L16.5312 6.03125L15.1875 7.375L11.4375 3.625V15.2187H9.5625Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadUpward);
export default __webpack_public_path__ + "static/media/uploadUpward.9abbc256b20fc8da36aaf78f1c5e40c1.svg";
export { ForwardRef as ReactComponent };